module.exports = __webpack_public_path__ + "static/img/nba-action-call.b280b423.png";